<script>
  import { link } from 'svelte-spa-router';
  import { authApi } from '../stores/api.js';
  import { _ } from '../lib/i18n.js';
  import AuthCard from '../components/AuthCard.svelte';
  import AuthNotice from '../components/AuthNotice.svelte';

  let email = '';
  let isLoading = false;
  let sent = false;
  let error = '';

  async function handleSubmit(event) {
    event.preventDefault();
    if (!email || isLoading) return;
    isLoading = true;
    error = '';
    try {
      // The answer is the same for every address: the page never says
      // whether an account exists.
      await authApi.requestPasswordReset(email.trim());
      sent = true;
    } catch {
      error = $_('auth.forgot.error');
    } finally {
      isLoading = false;
    }
  }
</script>

<AuthCard title={$_('auth.forgot.title')}>
  {#if sent}
    <AuthNotice tone="success" testid="forgot-password-sent">{$_('auth.forgot.sent')}</AuthNotice>
  {:else}
    <p class="text-sm" style="color: var(--color-text-muted);">{$_('auth.forgot.intro')}</p>
    {#if error}
      <AuthNotice tone="error" testid="forgot-password-error">{error}</AuthNotice>
    {/if}
    <form on:submit={handleSubmit} class="space-y-5">
      <div>
        <label for="forgot-email" class="label">{$_('auth.email')}</label>
        <input
          id="forgot-email"
          type="email"
          bind:value={email}
          required
          autocomplete="email"
          placeholder={$_('auth.emailPlaceholder')}
          class="input"
          disabled={isLoading}
        />
      </div>
      <button type="submit" class="w-full btn btn-primary h-12 text-base" disabled={isLoading || !email}>
        {isLoading ? `${$_('common.loading')}...` : $_('auth.forgot.submit')}
      </button>
    </form>
  {/if}
  <p class="text-center text-sm">
    <a href="/login" use:link class="font-bold text-primary-500 hover:underline">{$_('auth.backToLogin')}</a>
  </p>
</AuthCard>
